import { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import './_header.scss';
import strings from '@strings/LocalisedStrings';
import routes from '@src/route.config';
import { IconButton, Slide, useScrollTrigger } from '@mui/material';
import { UserProfile } from './UserProfile';
import { Menu, PersonOutline } from '@mui/icons-material';
import { useAppContext } from '@src/app/hooks/useAppContext';
import { adviserUrl } from '@src/app/utils/UrlBuilder';

const HeaderV2: FC = (): JSX.Element => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const { drawerExpanded, setDrawerExpanded } = useAppContext();

  const history = useHistory();
  const location = useLocation();

  const isOnboarding = location.pathname.includes('onboarding');

  const handleLoginPressed = async () => {
    await loginWithRedirect();
  };

  const LoginButton: FC<{ inverted?: boolean }> = (): JSX.Element => (
    <Button variant="contained" onClick={handleLoginPressed}>
      {strings.login}
    </Button>
  );

  const onProtectedRoute = routes.find((x) => x.path === location.pathname && x.protected) !== null;
  const trigger = useScrollTrigger({
    target: window,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      <AppBar position="relative" elevation={0} sx={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid #E9E9E9' }}>
        <Container maxWidth={onProtectedRoute && isAuthenticated ? false : 'lg'}>
          <Toolbar disableGutters sx={{ paddingTop: 2, paddingBottom: 2 }}>
            {onProtectedRoute && isAuthenticated && (
              <IconButton
                size="large"
                aria-label="toggle the sidenav menu"
                onClick={() => {
                  setDrawerExpanded(!drawerExpanded);
                }}
              >
                <Menu />
              </IconButton>
            )}

            <Box flex={1} />

            {!isOnboarding && (
              <>
                {onProtectedRoute && isAuthenticated && (
                  <Box display="flex" gap={1} alignItems="center">
                    <IconButton onClick={() => history.push(adviserUrl())} sx={{ display: 'flex' }} size="large">
                      <PersonOutline />
                    </IconButton>
                    <UserProfile />
                  </Box>
                )}
                {!isLoading && !isAuthenticated && <LoginButton />}
              </>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </Slide>
  );
};

export default HeaderV2;
